package floris.graphics.backoffice.pages.admin.categories

import floris.graphics.models.domain.models.Category
import floris.graphics.repo.CategoryRepo
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class CategoriesViewModel(
    private val categoryRepo: CategoryRepo = CategoryRepo,
    private val coroutineScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
) {
    private val _state = MutableStateFlow(CategoriesState())
    val state = _state.asStateFlow()

    private val _eventFlow = Channel<CategoriesUiEvent>()
    val eventFlow = _eventFlow.receiveAsFlow()

    fun onEvent(event: CategoriesEvent) = coroutineScope.launch {
        when (event) {
            CategoriesEvent.LoadCategories -> {
                _state.update { it.copy(isLoading = true) }
                val items = categoryRepo.getCategories()
                _state.update { it.copy(categories = items, isLoading = false) }
            }

            is CategoriesEvent.Navigate -> _eventFlow.send(CategoriesUiEvent.Navigate(event.route))
        }
    }

    init {
        onEvent(CategoriesEvent.LoadCategories)
    }
}

data class CategoriesState(
    val categories: List<Category> = emptyList(),
    val isLoading: Boolean = false,
    val errorText: String = ""
)

sealed class CategoriesEvent {
    data object LoadCategories : CategoriesEvent()
    data class Navigate(val route: String) : CategoriesEvent()
}

sealed class CategoriesUiEvent {
    data class Navigate(val route: String) : CategoriesUiEvent()
}
